<template>
    <div class="hello">
        <h1>{{ title }}</h1>

        <div class="spacer-small"></div>

        <div v-if="loading" class="kgk-loading-indicator"><i class="fas fa-spinner fa-spin"></i></div>
        <div v-else-if="companies">
            <table>
                <thead>
                    <tr>
                        <th>&nbsp;</th>
                        <th class="kgk-left">Firmenname</th>
                        <th style="white-space:nowrap">Anzahl Teilnehmende</th>
                        <th style="white-space:nowrap"># Läufe</th>
                        <th>Gelaufene Kilometer</th>
                    </tr>
                </thead>
                <tbody>
                    <tr v-for="(company, index) in companies"
                        :key="company.company_name">
                        <td class="kgk-left">
                            <div class="kgk-mobile-th">Platzierung:</div>
                            <span class="kgk-ranking-num">{{ index + 1 }}.</span>
                        </td>
                        <td class="kgk-left">
                            <div class="kgk-mobile-th kgk-left">Firmenname:</div>
                            {{ company.company_name }}
                        </td>
                        <td class="kgk-center">
                            <div class="kgk-mobile-th">Anzahl Teilnehmende:</div>
                            {{ company.user_count }}
                        </td>
                        <td class="kgk-center">
                            <div class="kgk-mobile-th">Anzahl Läufe:</div>
                            {{ company.total_runs }}
                        </td>
                        <td class="kgk-center">
                            <div class="kgk-mobile-th">Gelaufene Kilometer:</div>
                            <strong>{{ convertNumberReadable(company.total_km, 2) }} km</strong>
                        </td>
                    </tr>
                </tbody>
            </table>
        </div>
        <div v-else-if="error">
            <p>Fehler: {{error}}</p>
        </div>
    </div>
</template>

<script>
    import leaderboard from '../../api/leaderboard';

    export default {
        name: 'LeaderboardCompanies',
        props: {
            title: {
                type: String,
                required: false,
                default: 'Rangliste der Firmen',
            },
            all: {
                type: Boolean,
                required: false,
                default: false
            }
        },
        data() {
            return {
                companies: null,
                loading: false,
                error: null,
            }
        },
        mounted() {
            this.loading = true;

            leaderboard.getCompanies(
                this,
                this.all,
                data => {
                    this.companies = data.data;
                },
                () => this.error = 'Es ist ein Fehler aufgetreten',
                () => this.loading = false,
            );
        }
    }
</script>
